module.exports = __webpack_public_path__ + "3cd5818efc0064bdda5f22089a154833.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/purse.png
// module id = 2719
// module chunks = 0